import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';
import { THEMES, Theme } from './../constants/themes';
interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  isSetupComplete: boolean;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Theme Provider Props
interface ThemeProviderProps {
  children: ReactNode;
}

// Theme Provider Component
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(THEMES.default);
  const [isSetupComplete, setIsSetupComplete] = useState<boolean>(false);
  useEffect(() => {

    const hostname = window.location.hostname?.replace('www.', '');
    const themeMapping: Record<string, Theme> = {
      'ovum': THEMES.ovum,
      'lavenderportal': THEMES.lavender,
      'abchospital': THEMES.abchospital,
      'stluke': THEMES.stluke,
      'axis': THEMES.axis,
      'default': THEMES.abchospital,
    };
    const getClientName = () => {
      const clientName = Object.keys(themeMapping).find((key) => hostname.includes(key)) || 'default';
      return clientName;
    }
    setTheme(themeMapping[getClientName()] || THEMES.abchospital);
    setIsSetupComplete(true);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, isSetupComplete }}>
      {children}
    </ThemeContext.Provider>
  );
};
